import { globalColors } from 'globalStyle';
import { animations } from 'theme';

export const styles = {
  innerCardContent: {
    //*vertical padding in px - see the note in DesktopTotalImpressionCard.styles.ts (a % padding is width-relative and breaks row alignment)
    padding: '12px 4%',
    borderRadius: 'inherit',
    ...animations.appearanceEffect,
    '@media (min-width: 2250px)': {
      padding: '12px 1%',
    },
  },
  upperRow: {
    borderBottom: '1px solid #e6e9ed',
  },
  rightColumn: {
    padding: '2%',
    backgroundColor: globalColors.regular.background.greyCardBackground,
    borderRadius: '8px',
  },
  rightColumnUpperRow: {
    borderBottom: `1px solid ${globalColors.regular.background.greyDivider}`,
  },
  rightColumnBottomRow: {
    paddingTop: '5px',
  },
  rightColumnContent: {
    marginLeft: '5px',
  },
  rightColumnContentUpperRow: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: globalColors.regular.text.primary,
  },
  rightColumnContentBottomRow: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '14px',
    color: globalColors.regular.text.grey,
  },
};
